export default from './LoanOfficerCard';



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOfficerCard/index.js